import type { TrackOptions, TrackingDestination } from './types'

export function shouldReplayOnConsent(
  dest: TrackingDestination,
  options?: TrackOptions
): boolean {
  if (options?.replayOnConsent === false) return false
  if (options?.replayOnConsent === true) return true
  return dest.requiredConsent !== null
}

const REPLAY_DEDUPE_KEYS = [
  'productId',
  'Product ID',
  'Product id',
  'transaction_id',
  'page_path',
  'page_location',
  'categoryName',
  'Category',
  'orderId',
  'email',
] as const

export function buildReplayEventId(
  sourceEventName: string,
  mappedEventName: string,
  properties?: Record<string, any>,
  explicitEventId?: string
): string {
  if (explicitEventId) return explicitEventId

  const parts = [sourceEventName, mappedEventName]
  if (properties) {
    for (const key of REPLAY_DEDUPE_KEYS) {
      const value = properties[key]
      if (value != null && value !== '') {
        parts.push(String(value))
      }
    }
  }

  return parts.join(':')
}
